import { render, staticRenderFns } from "./switchToggle.vue?vue&type=template&id=fa25dea0&scoped=true&"
import script from "./switchToggle.vue?vue&type=script&lang=js&"
export * from "./switchToggle.vue?vue&type=script&lang=js&"
import style0 from "./switchToggle.vue?vue&type=style&index=0&id=fa25dea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa25dea0",
  null
  
)

export default component.exports